import { Injectable } from '@angular/core';
import { of, Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor() { }

  isLogin() {
    const isLogin = JSON.parse(localStorage.getItem('isLoggin')!);
    if ((isLogin == null || !isLogin) && (localStorage.getItem('system') != "SEAL" || localStorage.getItem('system') == null)) {
      localStorage.setItem('isLoggin', "false")
      localStorage.removeItem('system');
      localStorage.removeItem('currentUser');
      return false
    }
    return true;
  }

  isAuthorized() {
    var email = localStorage.getItem('prspUserEmail');
    if (email == null) return false;

    return true;
  }

  getToken() {
    return localStorage.getItem('prspUserToken')
  }
}
